import React from 'react';
import { HashRouter as Router, Route, Routes } from 'react-router-dom';

import { Content } from '../../components/shared/Content';
import ScrollToTop from '../../components/shared/ScrollToTop';
import SelectLoginMethod from './SelectLoginMethod';
import SelectSigningMethod from './SelectSigningMethod';

const SelectSigningAndLoginMethod: React.FC = () => {
    return (
        <Content className="cross-border-payment">
            <Router>
                <ScrollToTop />
                <Routes>
                    <Route path="/signing" Component={SelectSigningMethod} />
                    <Route path="/" Component={SelectLoginMethod} />
                </Routes>
            </Router>
        </Content>
    );
};

export default SelectSigningAndLoginMethod;
